import { render, staticRenderFns } from "./UserStaffs.vue?vue&type=template&id=dbdb7912"
import script from "./UserStaffs.vue?vue&type=script&lang=js"
export * from "./UserStaffs.vue?vue&type=script&lang=js"
import style0 from "./UserStaffs.vue?vue&type=style&index=0&id=dbdb7912&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports